import { all } from 'redux-saga/effects';
import AppSaga from './app-sagas';
import UpsellPopupSaga from './upsell-popup/upsell-popup-saga';
import UpsellBundleSaga from './upsell-bundle/upsell-bundle-saga';

export default function* rootSagas() {
  yield all([AppSaga(), UpsellPopupSaga(), UpsellBundleSaga()]);
}
